import elementExists from '../../../core/utils/element-exists';
import eventBus from '../../../core/services/event-bus';
import ProductJSON from './product-json';
const ProductColorSwatches = () => {
    const currentVariantJSON = document.querySelector('.current-variant-json');
    const productJSON = document.querySelector('.product-json');
    const colorSwatches = document.querySelectorAll('[data-option-key="Color"] .btn-swatch' );
    let { productData , currentVariant } = ProductJSON();
 
    try{ currentVariant = JSON.parse(currentVariantJSON.innerHTML)
    }catch( $e ){ currentVariant = false; }

    try{ productData = JSON.parse(productJSON.innerHTML)
    }catch( $e ){ productData = false; }

    const updateColorImages = function(){
        const sizePosition = productData.options.findIndex( option => option == 'Size');
        const colorPosition = productData.options.findIndex( option => option == 'Color');

        const size = currentVariant.options[ sizePosition ];

        colorSwatches.forEach( swatch => {
            const color = swatch.dataset.value;
            const variantWithImage = productData.variants.find( variant => {
                if( variant.options[sizePosition] == size 
                    && variant.options[colorPosition] == color 
                    && variant.featured_image !== null ){
                        return variant;
                }
            });
            if( variantWithImage ){
                const imageContainer=  swatch.querySelector('.swatch-image-container');
                // swatch.style.backgroundColor = 'yellow';
                const src = variantWithImage.featured_image.src.replace( `.png` , '_small.png').replace( '.jpg' , '_small.jpg');
                imageContainer.style.backgroundImage = `url(${src})`;
            }
        })
    }
    const preloadImages = function(){
        productData.variants.forEach( variant => {
            if( variant.featured_image !== null ){
                const image = new Image();
                const src = variant.featured_image.src.replace( `.png` , '_small.png').replace( '.jpg' , '_small.jpg');
                image.src = src
            }
        });
    }
    eventBus.on(eventBus.types.OptionsSelected , function( $event ){
        currentVariant = $event.detail;
        updateColorImages();
    })
    preloadImages();
    updateColorImages();

}

export default ProductColorSwatches;

